<script>
    import FormModal from '../../Forms/FormModal.svelte';
    import { generateCSV } from '../../lib/csv';
    import {downloadFile} from '../../Utilities/util';

    export let headers;
    export let libraryName;

    function downloadTemplate() {
        let csv = generateCSV(headers, []);


        downloadFile(csv, `${libraryName}_import_template.csv`, 'text/csv');
    }
</script>

<FormModal {...$$restProps}>
    <div slot="body-pre">
        <div class="button" on:click={downloadTemplate}>
            Download Import Template
        </div>
    </div>
</FormModal>
